import styles from '@shared/components/atoms/ApprovalStatus/ApprovalStatus.module.scss';

const STATUS_CLASS_MAP = {
  결재완료: 'completed',
  결재중: 'pending',
  반려: 'rejected',
  수정요청: 'rejected', // 수정요청도 반려와 동일한 빨간색 스타일 적용
  삭제: 'rejected', // 삭제도 반려와 동일한 빨간색 스타일 적용
};
/**
 *
 * @param {React.ReactNode} children - 결재 상태
 * @returns
 */
export default function ApprovalStatus({ children, variant }) {
  const classKey = variant || STATUS_CLASS_MAP[children] || 'default';

  return <div className={`${styles.approvalContainer} ${styles[classKey]}`}>{children}</div>;
}
